module.exports = __webpack_public_path__ + "media/images/convenios/col_kinesiologos-086b488ed23f748e5cd34517e85e3a11.jpg";